//==============================================
// Navigation: Moblie Menu
//==============================================


export let navMenu = () => {
   

	const headerButtonNav = $('.header__button-nav'),
		headerButtonNavControle = $('.header__button-nav-control'),
		headerLogo = $('.header__logo'),
		headerNav = $('.header__nav');
	
	headerButtonNavControle.on('click keypress', function(){

		$(this).trigger('blur');

		// Check Aria Expanded: False add active classes
		if($(this).attr('aria-expanded') === 'false'){

			$(this).attr('aria-expanded', 'true');

			headerButtonNav.addClass('header__button-nav--active');

			headerNav.addClass('header__nav--active');

			headerLogo.addClass('header__logo--active');

		// Check Aria Expanded: True remove active classes
		}else{

			$(this).attr('aria-expanded', 'false');

			headerButtonNav.removeClass('header__button-nav--active');

			headerNav.removeClass('header__nav--active');

			headerLogo.removeClass('header__logo--active');

		}
		
	});
};